export default __webpack_public_path__ + "static/liveness-c321493f6ee855b617b41a5f0f9b49bd.png";